const workforceReducer = (
  state = {
    captureSummary: null,
    workforceSummary: null,
    data: null,
    archivedData: null,
    loading: false,
    results: null,
    roles: null,
    total: null,
    operations: null
  },
  action
) => {
  switch (action.type) {
    case "SET_WORKFORCE_LOADING":
      return {
        ...state,
        loading: action.payload.loading
      };

    case "PUT_WORKFORCE_DATA":
      return {
        ...state,
        data: action.payload.data,
        archivedData: action.payload.archivedData
      };

    case "PUT_WORKFORCE_RESULTS":
      return {
        ...state,
        results: action.payload.data
      };

    case "SET_WORKFORCE_COUNT":
      return {
        ...state,
        total: action.payload.count
      };

    case "SET_ROLES_DATA":
      return {
        ...state,
        roles: action.payload.data
      };

    case "SET_CAPTURE_SUMMARY_DATA":
      return {
        ...state,
        captureSummary: action.payload.data
      };

    case "SET_WORKFORCE_SUMMARY_DATA":
      return {
        ...state,
        workforceSummary: action.payload.data
      };

    case "SET_OPERATIONS_DATA":
      return {
        ...state,
        operations: action.payload.data
      };

    case "RESET":
      return state;

    default:
      return state;
  }
};
export default workforceReducer;
